export interface Location {
  latitude: number;
  longitude: number;
}

export interface RefuelingEvent {
  id?: string;
  date: string;
  mileage: number;
  pricePerLiter: number;
  liters: number;
  user: string;
  location: Location
}

export interface RefuelingHistoryEntry {
  id: string;
  date: Date;
  mileage: number;
  pricePerLiter: number;
  liters: number;
  user: string;
}

export function HistoryEntryFromEvent(re: RefuelingEvent) : RefuelingHistoryEntry {
  return {
    id: re.id ?? "",
    date: new Date(re.date),
    liters: re.liters,
    pricePerLiter: re.pricePerLiter,
    mileage: re.mileage,
    user: re.user
  };
}
